module.exports = __webpack_public_path__ + "img/bingo.6c5db578.jpg";